import { SelectOption } from '@/components/common/SelectDropdown';

export const industries: SelectOption[] = [
  { label: 'Technology', value: 'technology' },
  { label: 'Healthcare', value: 'healthcare' },
  { label: 'Finance', value: 'finance' },
  { label: 'Education', value: 'education' },
  { label: 'Manufacturing', value: 'manufacturing' },
  { label: 'Retail', value: 'retail' },
  { label: 'Consulting', value: 'consulting' },
  { label: 'Real Estate', value: 'real_estate' },
  { label: 'Transportation', value: 'transportation' },
  { label: 'Entertainment', value: 'entertainment' },
  { label: 'Food & Beverage', value: 'food_beverage' },
  { label: 'Other', value: 'other' },
];

export const getIndustryLabel = (industry: string) => {
  return industries.find((i) => i.value === industry)?.label;
};
